module.exports = __webpack_public_path__ + "img/ipad-gestures-2.d9b9e71.jpg";